export interface Value {
    key: string
    label: string
    selected: boolean
    value: string
}

export enum TimeframeOptions {
    ANY = 'ANY',
    YESTERDAY = 'YESTERDAY',
    LAST_7_DAYS = 'LAST7DAYS',
    LAST_30_DAYS = 'LAST30DAYS',
}

export enum SurroundingOptions {
    REGIONAL = 'REGIONAL',
    NATIONWIDE = 'NATIONWIDE',
}
